import React, { useMemo } from "react";

import { ParsedTCMPCUnit, ParsedClassroom } from "@examspark/types";

import ResourcesTable from "../../resources/ResourcesTable";

const ClassroomUnitResources = (props: {
  classroom: ParsedClassroom;
  unit: ParsedTCMPCUnit;
}) => {
  const location = useMemo(
    () => ({
      ...props.classroom,
      resourceUnit: props.unit,
    }),
    [props.classroom, props.unit],
  );

  return <ResourcesTable location={location} />;
};

export default ClassroomUnitResources;
